import { Link } from "react-router-dom";
import { UserRound, Phone } from "lucide-react";
import { fileUrl } from "@/lib/api";
import { SectionTitle } from "./SectionTitle";

export const BoardCard = ({ p, featured = false, showContact = false }) => (
  <div className={`card-hover rounded-3xl p-6 border ${featured ? "emerald-bg text-white border-transparent" : "bg-white border-emerald-900/10"}`} data-testid={`board-card-${p.id}`}>
    <div className={`h-20 w-20 rounded-2xl overflow-hidden flex items-center justify-center ${featured ? "bg-[#d4af37] text-emerald-950" : "bg-emerald-50 text-emerald-800"}`}>
      {p.photo_path ? <img src={fileUrl(p.photo_path)} alt={p.name} className="h-full w-full object-cover" /> : <UserRound size={30} />}
    </div>
    <p className={`mt-5 text-xs font-semibold uppercase tracking-widest ${featured ? "text-[#d4af37]" : "text-emerald-700"}`}>{p.position}</p>
    <p className={`mt-1 font-bold text-lg leading-snug ${featured ? "text-white" : "text-emerald-950"}`}>{p.name}</p>
    <p className={`mt-1 text-xs ${featured ? "text-emerald-200" : "text-slate-500"}`}>Periode {p.period}</p>
    {showContact && p.phone && (
      <a href={`https://wa.me/${p.phone.replace(/\D/g, "").replace(/^0/, "62")}`} target="_blank" rel="noopener noreferrer" className={`mt-4 inline-flex items-center gap-2 text-sm font-medium ${featured ? "text-[#d4af37]" : "text-emerald-800"} hover:underline`} data-testid={`board-contact-${p.id}`}>
        <Phone size={14} /> {p.phone}
      </a>
    )}
  </div>
);

export const BoardSection = ({ board = [] }) => (
  <section id="pengurus" className="scroll-mt-24" data-testid="board-section">
    <SectionTitle eyebrow="Struktur Organisasi" title="Pengurus DKM Al-Iman" desc="Dewan Kemakmuran Masjid yang mengemban amanah jamaah dalam mengelola ibadah, kegiatan, dan keuangan masjid. Silakan hubungi pengurus untuk informasi lebih lanjut." more="/pengurus" moreTestId="board-see-all" />
    <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5 gap-5">
      {board.slice(0, 5).map((p, i) => <BoardCard key={p.id} p={p} featured={i === 0} />)}
    </div>
    {board.length === 0 && <p className="mt-6 text-sm text-slate-500">Data pengurus belum tersedia.</p>}
    {board.length > 5 && <Link to="/pengurus" className="sr-only">Semua pengurus</Link>}
  </section>
);
